import { lazy } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { hasLocationParams } from "../../utils/addressSearch";

const AppConsolePage = lazy(() => import("./AppConsolePage"));
const AppResultPage = lazy(() => import("./AppResultPage"));

/**
 * `/app` after the console cutover (feature-console-redesign FRD §5, step 2).
 *
 * With an address in the URL it is the console. Without one it is still the
 * entry screen, which lives in `AppResultPage`'s zero state: the console has
 * no entry screen of its own, and every bare `/app` link in the app (nav,
 * brand menu, footer, 404) expects one.
 */
export const AppHome = () => {
  const [searchParams] = useSearchParams();
  return hasLocationParams(searchParams) ? <AppConsolePage /> : <AppResultPage />;
};

/**
 * `/app/v2` was the console's address during the rollout. Links people shared
 * or bookmarked then keep working: same query and hash, on `/app`.
 */
export const LegacyConsoleRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: "/app", search, hash }} replace />;
};
